import { types as actions } from '../actions';
import { getUpdatedPermissions } from '../../constants/perms';

const defaultState = {
  users: [],
  verificationLink: null
};

export default (state = defaultState, action = {}) => {
  switch (action.type) {
    case actions.ADDED_USER:
      var newUser = { data: action.user.data[0] };
      return {
        ...state,
        users: [...state.users, newUser]
      };
    case actions.GET_USER:
      return {
        ...state,
        users: [...state.users, action.user]
      };
    case actions.SET_USER:
      return {
        ...state,
        users: [...action.user]
      };
    case actions.DELETE_SITE_USER:
      state.users.filter(user => {
        return user.data.id !== action.siteUserId;
      });
      return {
        ...state
      };
    case actions.REMOVE_SITE_USER_SUCCESS:
      const userListSuccess = state.users.filter(user => {
        return user.data.id !== action.siteUserId;
      });
      return {
        ...state,
        users: userListSuccess
      };
    case actions.SHOW_MODAL: {
      const shouldShowModal = true;
      return {
        ...state,
        shouldShowModal
      };
    }
    case actions.RESET_MODAL: {
      const shouldShowModal = false;
      return {
        ...state,
        shouldShowModal
      };
    }
    case actions.EDITED_SITE_USER: {
      let oldUsers = state.users;
      const actionuserId = action.user.id;

      let editedUser = oldUsers.find(function(user) {
        return user.data.id === actionuserId;
      });

      const updatedPermsList = action.user.userPermissions;
      let editedUserPermList = editedUser.data.assetInfo.metadata.props;

      const newPermissions = getUpdatedPermissions(updatedPermsList, 'String');
      editedUser.data.assetInfo.metadata.props = {
        ...editedUserPermList,
        ...newPermissions
      };

      const objIndex = oldUsers.findIndex(function(user) {
        return user.data.id === actionuserId;
      });

      const updatedUsers = [
        ...state.users.slice(0, objIndex),
        editedUser,
        ...state.users.slice(objIndex + 1)
      ];

      return {
        ...state,
        users: updatedUsers
      };
    }
    case actions.LINK_VIEWED: {
      const verificationLink = action.data.verificationLink;
      return {
        ...state,
        verificationLink,
      }
    }

    case actions.CLEAR_INVITE_LINK: {
      return {
        ...state,
        verificationLink: null
      }
    }

    case actions.EDIT_USER:
      return {
        ...state
      };

    case actions.LOGGED_OUT:
       return defaultState;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/users/index.js